// format time
function formatTime(time) {
    console.log(time);
    var minutes = Math.floor(time / 60);
    if(minutes < 10) {
        minutes = '0' + minutes;
    }
    var seconds = Math.floor(time - minutes * 60);
    if (seconds < 10) {
        seconds = '0' + seconds;
    }
    return minutes + ':' + seconds;
}

// podcast player
function podcastsInit() {
    //podcast
    let podcasts = document.querySelectorAll('.podcast-audio-not-init');
    podcasts.forEach((el) => {
        let playButton = el.querySelector('.podcast-play-button');
        let seekBar = el.querySelector('.podcast-seek-bar');
        let fillBar = el.querySelector('.podcast-fill-bar');
        let audio = el.querySelector('audio');
        let time = el.querySelector('.podcast-time');

        audio.addEventListener('loadedmetadata', function() {
            time.innerText = '00:00 / ' + formatTime(audio.duration);
        });

        playButton.addEventListener('click', function (e) {
            let play = playButton.querySelector('.play');
            let pause = playButton.querySelector('.pause');
            if (audio.paused) {
                audio.play();
                play.style.display = 'none';
                pause.style.display = 'block';
            } else {
                audio.pause();
                pause.style.display = 'none';
                play.style.display = 'block';
            }
        });
        audio.addEventListener('timeupdate', function () {
            // seekbar
            var fillWidth = (audio.currentTime / audio.duration) * seekBar.offsetWidth;
            fillBar.style.width = fillWidth + 'px';
            // time
            time.innerHTML = '<b>' + formatTime(audio.currentTime) + '</b> / ' + formatTime(audio.duration);
        });

        seekBar.addEventListener('click', function (e) {
            var rect = seekBar.getBoundingClientRect();
            var clickPosition = e.clientX - rect.left;
            var newTime = (clickPosition / rect.width) * audio.duration;
            audio.currentTime = newTime;
        });

        el.classList.remove('podcast-audio-not-init');
    });
}

// gform
function animateFormLabel() {
    let gformInputs = document.querySelectorAll('.gform_wrapper input, .gform_wrapper textarea');
    for (let i = 0; i < gformInputs.length; i++) {
        if (gformInputs[i].value !== '') {
            gformInputs[i].parentNode.parentNode.classList.add('gfield--active');
        }
        gformInputs[i].addEventListener('focus', function () {
            this.parentNode.parentNode.classList.add('gfield--active');
        });
        gformInputs[i].addEventListener('blur', function () {
            if (gformInputs[i].value === '') {
                this.parentNode.parentNode.classList.remove('gfield--active');
            }
        });
    }

    let gformSelects = document.querySelectorAll('.gform_wrapper select');
    for (let i = 0; i < gformSelects.length; i++) {
        gformSelects[i].parentNode.parentNode.classList.add('gfield--active');
    }
}

function gFormButtonClicked() {
    let gFormButton = document.querySelector('.gform_button');
    gFormButton.addEventListener('click', function () {
        setTimeout(function () {
            animateFormLabel();
        }, 1000);
        setTimeout(function () {
            animateFormLabel();
        }, 2000);
    });
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('body').classList.add('loaded');
    // menu mobile
    let hamburger = document.querySelector('.hamburger');
    let menuMobile = document.querySelector('.header__mobile-menu');
    hamburger.addEventListener('click', function () {
        hamburger.classList.add('is-active');
        menuMobile.classList.add('header__mobile-menu--visible');
    });
    let closeMenu = document.querySelector('.menu-close');
    closeMenu.addEventListener('click', function () {
        hamburger.classList.remove('is-active');
        menuMobile.classList.remove('header__mobile-menu--visible');
    });
    // sous menus mobile
    let menuElTitle = document.querySelectorAll('.menu-el__title');
    for (let i = 0; i < menuElTitle.length; i++) {
        menuElTitle[i].addEventListener('click', function () {
            let submenu = this.nextElementSibling;
            submenu.classList.toggle('menu-el__submenu--visible');
            menuElTitle[i].classList.toggle('menu-el__title--active');
        });
    }
    // sous menus
    for (let i = 0; i < 4; i++) {
        let menuEl = document.querySelector('.menu-el-' + (i + 1));
        let submenu = document.querySelector('.submenu-' + (i + 1));
        menuEl.addEventListener('click', function () {
            for (let j = 0; j < 4; j++) {
                if (j !== i) {
                    let submenu = document.querySelector('.submenu-' + (j + 1));
                    let menuEl = document.querySelector('.menu-el-' + (j + 1));
                    submenu.classList.remove('submenu--visible');
                    menuEl.classList.remove('menu-el--active');
                    submenu.style.zIndex = 100;
                }
            }
            submenu.classList.toggle('submenu--visible');
            menuEl.classList.toggle('menu-el--active');
            submenu.style.zIndex = 101;
        });
    }
    document.querySelector('main').addEventListener('click', function () {
        for (let i = 0; i < 4; i++) {
            let submenu = document.querySelector('.submenu-' + (i + 1));
            let menuEl = document.querySelector('.menu-el-' + (i + 1));
            submenu.classList.remove('submenu--visible');
            menuEl.classList.remove('menu-el--active');
            submenu.style.zIndex = 100;
        }
    });

    // agir avec nous morphing
    let agirAvecNous = document.querySelector('.liens-agir-avec-nous');
    let agirAvecNousTitle = document.querySelector('.liens-agir-avec-nous h2');
    if (agirAvecNousTitle) {
        agirAvecNousTitle.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            agirAvecNous.classList.toggle('active');
        });
        document.querySelector('main').addEventListener('click', function () {
            agirAvecNous.classList.remove('active');
        });
    } else {
        agirAvecNous.style.display = 'none';
    }

    // lang choice
    document.getElementById('lang_choice_1').addEventListener('change', function (event) {
        location.href = event.currentTarget.value;
    });
    document.getElementById('lang_choice_2').addEventListener('change', function (event) {
        location.href = event.currentTarget.value;
    });

    // newsletter popup

    let popupNewsletterButtons = document.querySelectorAll('.btn-popup-newsletter');
    for (let i = 0; i < popupNewsletterButtons.length; i++) {
        popupNewsletterButtons[i].addEventListener('click', function (e) {
            e.preventDefault();
            document.querySelector('.popup-newsletter').classList.add('popup-newsletter--visible');
        });
    }
    let popupNewsletterClose = document.querySelector('.newsletter-close-btn');
    popupNewsletterClose.addEventListener('click', function () {
        document.querySelector('.popup-newsletter').classList.remove('popup-newsletter--visible');
    });

    // gform

    animateFormLabel();

    setInterval(function () {
        gFormButtonClicked();
    }, 5000);

    // read more
    let readMoreButtons = document.querySelectorAll('.wp-block-read-more');

    readMoreButtons.forEach((button) => {
        button.removeAttribute('href');
        button.style.display = 'flex';
        let nextElement = button.nextElementSibling;

        if (nextElement.classList.contains('wp-block-group')) {
            nextElement.classList.add('wp-block-group--read-less');
        }
        button.addEventListener('click', function () {
            nextElement.classList.add('is-open');
            button.style.display = 'none';
        });
    });

    //video player
    let videoButtons = document.querySelectorAll('.btn-video');
    videoButtons.forEach((el) => {
        el.addEventListener('click', function (e) {
            let videoPlayer = document.querySelector('.post-list-video-player');
            let title = videoPlayer.querySelector('h2');
            let video = videoPlayer.querySelector('video');
            let videoSrc = el.getAttribute('data-video');
            video.src = videoSrc;
            title.innerHTML = el.getAttribute('data-title');
            videoPlayer.style.display = 'flex';
            video.play();
        });
    });
    let closeVideoBtn = document.querySelector('.post-list-video-close-btn');
    if (closeVideoBtn) {
        closeVideoBtn.addEventListener('click', function (e) {
            let videoPlayer = document.querySelector('.post-list-video-player');
            let video = videoPlayer.querySelector('video');
            video.pause();
            videoPlayer.style.display = 'none';
        });
    }

    // parallax
    var parallaxElements = Array.from(document.querySelectorAll('.parallax-el'));

    window.addEventListener('scroll', function () {
        var scrolledHeight = window.pageYOffset,
            viewportHeight = window.innerHeight;
        parallaxElements.forEach(function (parallaxEl) {
            var parent = parallaxEl.offsetParent;
            if (parent) {
                var parentTop = parent.offsetTop,
                    elTop = parentTop + parallaxEl.offsetTop,
                    elBottom = elTop + parallaxEl.offsetHeight;
                if (elTop <= scrolledHeight + viewportHeight && elBottom >= scrolledHeight) {
                    parallaxEl.style.transform = 'translate3d(0,' + (scrolledHeight - elTop) / 8 + 'px, 0)';
                } else {
                    parallaxEl.style.transform = 'translate3d(0,0,0)';
                }
            }
        });
    });

    podcastsInit();
});
